import {React, useEffect} from 'react'
import logo from './img/lgo.png' /* logo */
import './scroll.css'


function Nav() {
    useEffect(() => {
        const handleScroll = () => {
          const navbarGOMA = document.querySelector('.navbarGOMA');
          const logo = document.querySelector('.logo');
          const logox = document.querySelector('.logo-text');

          if (window.scrollY > 10) {
            navbarGOMA.classList.add('scrolled');
            logo.classList.add('hide-logo');
            logox.classList.add('hide-logo');
          } else {
            navbarGOMA.classList.remove('scrolled');
            logo.classList.remove('hide-logo');
            logox.classList.remove('hide-logo');
          }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

        function scrollToTop(event) {
          window.scrollTo({
              top: 0,
              behavior: 'smooth'
          });
          event.preventDefault();
          document.getElementById("scrollableDiv").scrollTo({
              top: 0,
              behavior: 'smooth'
          });
      }

    return (
      <div className='GOMA'>
        <div className="top-nav">
            <div className='logo-text'>
              <a href="adminGOMA">
                <img src={logo} className="logo" style={{ width: '52px', position: 'fixed', top: 0, zIndex: 1}} />
              </a>
{/* title */}       <a href="adminGOMA" id='log-txt' className="logtex"><strong>
Institut Supérieur Pédagogique et Technique - GOMA
                </strong></a>
            </div>
          <nav className="navbarGOMA">
          <ul className="nav-links">
                  {/* <li style={{ marginLeft: "350px" }}><a href="#academic"><strong>Academique</strong></a></li> */}
                  {/* <li><a href="#home"><strong>Bibliotheque</strong></a></li> */}
                  {/* <li><a href="#home"><strong>Inscription</strong></a></li>
                  <li><a href="gallery"><strong>Gallery</strong></a></li> */}
                  <li><a href="#home"><strong>CONTACT</strong></a></li>
                  <li><a href="login"><strong>LOGIN</strong></a></li>
              </ul>
          </nav>
          <br/>
          <br/>
        </div>
      </div>
    )
}

export default Nav;